module.exports = __webpack_public_path__ + "img/detail5.e6ea03ed.jpg";